import { AppStateSlice } from '$tablet-app/src/app/stores/app_state';
import { CurrentUserStore } from './types';

export const createCurrentUserStore: AppStateSlice<CurrentUserStore> = (
  set
) => ({
  setCurrentUserID(current_user_id) {
    set({ current_user_id });
  },
  setCurrentUser(current_user) {
    set({ current_user, current_user_id: current_user?.id });
  },
  setUsers(users) {
    set({ users });
  },
});
